import type { TeamRole } from '@/shared/services/team.service';

/**
 * What each role may open, as the API enforces it (AL-06): the inbox is for
 * owners, admins and editors; analytics and the customer reports add
 * viewers; clients keep posts and approvals; billing admins the plan and
 * invoices. While the role is still loading (null) nothing is hidden.
 */
export function canReadInbox(role: TeamRole | null): boolean {
  return role === null || role === 'owner' || role === 'admin' || role === 'editor';
}

export function canReadAnalytics(role: TeamRole | null): boolean {
  return canReadInbox(role) || role === 'viewer';
}
